/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import { dateOnlyToQuery } from './DateOnly';
import type {
  CourtHearingResponse,
  ProblemDetails,
  ValidationProblemDetails,
} from '../models/index';
import {
    CourtHearingResponseFromJSON,
    CourtHearingResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface GetCourtHearingsRequest {
    from: Date;
    to: Date;
    courtId?: string;
    counselorId?: string;
}

/**
 * CourtHearingsApi - interface
 * 
 * @export
 * @interface CourtHearingsApiInterface
 */
export interface CourtHearingsApiInterface {
    /**
     * 
     * @param {Date} from 
     * @param {Date} to 
     * @param {string} [courtId] 
     * @param {string} [counselorId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourtHearingsApiInterface
     */
    getCourtHearingsRaw(requestParameters: GetCourtHearingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourtHearingResponse>>>;

    /**
     */
    getCourtHearings(requestParameters: GetCourtHearingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourtHearingResponse>>;

}

/**
 * 
 */
export class CourtHearingsApi extends runtime.BaseAPI implements CourtHearingsApiInterface {

    /**
     */
    async getCourtHearingsRaw(requestParameters: GetCourtHearingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CourtHearingResponse>>> {
        if (requestParameters['from'] == null) {
            throw new runtime.RequiredError(
                'from',
                'Required parameter "from" was null or undefined when calling getCourtHearings().'
            );
        }

        if (requestParameters['to'] == null) {
            throw new runtime.RequiredError(
                'to',
                'Required parameter "to" was null or undefined when calling getCourtHearings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['from'] != null) {
            queryParameters['from'] = dateOnlyToQuery(requestParameters['from'] as Date);
        }

        if (requestParameters['to'] != null) {
            queryParameters['to'] = dateOnlyToQuery(requestParameters['to'] as Date);
        }

        if (requestParameters['courtId'] != null) {
            queryParameters['courtId'] = requestParameters['courtId'];
        }

        if (requestParameters['counselorId'] != null) {
            queryParameters['counselorId'] = requestParameters['counselorId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/court-hearings`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CourtHearingResponseFromJSON));
    }

    /**
     */
    async getCourtHearings(requestParameters: GetCourtHearingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CourtHearingResponse>> {
        const response = await this.getCourtHearingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
